import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/admin/audit-trails')({
  staticData: {
    title: 'route.admin.auditTrails',
    crumb: 'route.admin.auditTrails',
    permissions: ['audit_trails_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
